export default __webpack_public_path__ + "static/media/bicycle-steve.fba228b1.jpg";